import { VoucherDetailPage } from '@/features/voucher/pages/VoucherDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/voucher/$id/detail')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["voucher.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VoucherDetailPage,
})
